import script from "./recentWork.vue?vue&type=script&lang=ts&setup=true"
export * from "./recentWork.vue?vue&type=script&lang=ts&setup=true"

import "./recentWork.vue?vue&type=style&index=0&id=9337d740&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9337d740"]])

export default __exports__